/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: block;
}
:host .title {
  font-size: calc(14rem/14);
}
:host .title:hover {
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}
:host > .accordion {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  padding-right: calc(12rem/14);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  height: calc(34rem/14);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host > .accordion div {
  flex: 0 0 auto;
}
:host > .accordion > .click-area {
  cursor: pointer;
  display: flex;
  flex-shrink: 1;
}
:host > .accordion > .click-area > svg {
  flex: 0 0 auto;
  height: calc(24rem/14);
  width: calc(24rem/14);
  cursor: pointer;
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host > .accordion > .click-area > svg.active {
  transform: rotate(180deg);
}
:host > .accordion > .click-area > svg.prepend {
  order: -1;
}
:host > .panel {
  display: none;
}
:host > .panel.open {
  display: block;
}

:host([open]) .title {
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}

:host([hidden]) {
  display: none;
}`;
export { style };
